import  { useEffect, useState } from 'react'
import {db} from '../firebase'

function useObtenerBalance (companyuid){

    const [userBalance,setUserBalance] =  useState(null)
    const [loadingBalance, setLoading] = useState(false)
    const [errorBalance, setError] = useState(null)
  
    useEffect(()=>{
      if(companyuid){
      fetchData(companyuid.trim())
      }
    },[companyuid])
  
  
    const fetchData = async (companyuid) => {
      try {
        setLoading(true)
        const accountants = await db.collection(`${process.env.REACT_APP_COL_BALANCE}`)
        .doc(companyuid)
        .get();
        var dataResult = accountants.data();
  
        setUserBalance(dataResult)
        setLoading(false)
      } catch (error) {
        console.log(error)
        setError(true)
      }
    }
  
    return {userBalance, loadingBalance, errorBalance}
}

export default useObtenerBalance